import { useMutation } from "@tanstack/react-query"
import { changePassword, updateSecurity } from "../services/securityService"
import type {
	ChangePasswordRequest,
	ChangePasswordResponse,
	UpdateSecurityRequest,
	UpdateSecurityResponse
} from "../services/securityService"
import type { AxiosError } from "axios"

type ApiError = AxiosError<{
	message: { message: string; error: string; statusCode: number }
}>

export const useSecurityMutations = () => {
	const changePasswordMutation = useMutation<
		ChangePasswordResponse,
		ApiError,
		ChangePasswordRequest
	>({
		mutationFn: changePassword
	})

	const updateSecurityMutation = useMutation<
		UpdateSecurityResponse,
		ApiError,
		UpdateSecurityRequest
	>({
		mutationFn: updateSecurity
	})

	return {
		changePassword: changePasswordMutation,
		updateSecurity: updateSecurityMutation
	}
}
